import { createAction, props } from '@ngrx/store';
import {
  SecurityScoreComplianceData,
  SecurityScoreComplianceSection,
  SecurityScoreDataset,
  SecurityScoreDomeOverview,
} from '../../../../../../../../shared/src/lib/core/interfaces';
import {
  SecurityScoreComplianceSectionKey,
  SecurityScoreReloadableView,
  SecurityScoreView,
  SecurityScoreViewBy,
} from './security-score.model';

export const loadAllSecurityScoreViews = createAction(
  '[@diso/securityScore] loadAllSecurityScoreViews',
  props<{ viewBy: SecurityScoreViewBy }>(),
);

// Silent re-fetch of every view with its current viewBy (no loading state),
// dispatched when a live notification reports that overview data changed.
export const refreshSecurityScoreViews = createAction(
  '[@diso/securityScore] refreshSecurityScoreViews',
);

export const setActiveView = createAction(
  '[@diso/securityScore] setActiveView',
  props<{ view: SecurityScoreView }>(),
);

export const setViewBy = createAction(
  '[@diso/securityScore] setViewBy',
  props<{ view: SecurityScoreReloadableView; viewBy: SecurityScoreViewBy }>(),
);

export const setComplianceViewBy = createAction(
  '[@diso/securityScore] setComplianceViewBy',
  props<{
    section: SecurityScoreComplianceSectionKey;
    viewBy: SecurityScoreViewBy;
  }>(),
);

export const loadSecurityScoreRisks_success = createAction(
  '[@diso/securityScore] loadSecurityScoreRisks_success',
  props<{ dataset: SecurityScoreDataset; dome: SecurityScoreDomeOverview }>(),
);

export const loadSecurityScoreDomains_success = createAction(
  '[@diso/securityScore] loadSecurityScoreDomains_success',
  props<{ dataset: SecurityScoreDataset; dome: SecurityScoreDomeOverview }>(),
);

export const loadSecurityScoreCompliance_success = createAction(
  '[@diso/securityScore] loadSecurityScoreCompliance_success',
  props<{
    compliance: SecurityScoreComplianceData;
    dome: SecurityScoreDomeOverview;
  }>(),
);

export const loadSecurityScoreComplianceSection_success = createAction(
  '[@diso/securityScore] loadSecurityScoreComplianceSection_success',
  props<{
    section: SecurityScoreComplianceSectionKey;
    data: SecurityScoreComplianceSection | null;
  }>(),
);

export const loadSecurityScoreView_success = createAction(
  '[@diso/securityScore] loadSecurityScoreView_success',
);

export const loadSecurityScoreView_failure = createAction(
  '[@diso/securityScore] loadSecurityScoreView_failure',
);
